import { GeneralAvailability } from "./GeneralAvailability";
import { GoogleCalendarSetting } from "./GoogleCalendarSetting";
import { RescheduleFee } from "./RescheduleFee";
import { SameDayNotice } from "./SameDayNotice";
import { TimeBreak } from "./TimeBreak";
import { Timezone } from "./Timezone";

import "./availability.scss";

export function Availability() {
	return (
		<div className="right-column-content-container">
			<div className="availability-container">
				<Timezone />
				<GoogleCalendarSetting />
				<GeneralAvailability />
				<SameDayNotice />
				<TimeBreak />
				<RescheduleFee />
			</div>
		</div>
	);
}
